import { api } from "../App";
import { GET_INFO_MAIN } from "./types";


export const getInfoMain = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/version`);
    dispatch({ type: GET_INFO_MAIN, payload: data });
  } catch (ERR) {
  }
};
